import React, { memo } from 'react';
import useAuth from '../../../../hooks/auth';
import BaseNavbar from '../base';
import Products from './products';
import UserBlock from './user';

export default memo(() => {
  const { user } = useAuth();

  return (
    <BaseNavbar>
      <Products available={user.products} />
      <UserBlock user={user} />
    </BaseNavbar>
  );
});
